import { NavigationCard } from "@/components/navigation-card";

export function SettingsCard() {
  return (
    <NavigationCard
      title="Adjust Settings"
      splash="https://images.unsplash.com/photo-1526897515823-424cd784315f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1NDM2NzN8MHwxfHNlYXJjaHwxfHxzZXR0aW5nc3xlbnwwfDB8fHwxNzQ1NTIzMTk2fDA&ixlib=rb-4.0.3&q=80&w=200"
      description="Control a variety of different settings that impact your game."
      to="/settings"
    />
  );
}
